import React, { useState } from 'react';
import GenericDialog from '../../../../components/dialog/GenericDialog';
import ModifyUnitTab from './ModifyUnitTab';
import RefranchiseUnitTab from './RefranchiseUnitTab';

export default function UnitActionsDialog({
  open,
  onClose,
  initialData,
  onSubmit,
  defaultTabKey = 'modify',
}) {
  const [, setLoading] = useState(false);

  const tabs = [
    {
      key: 'modify',
      label: 'Modify Details',
      render: () => (
        <ModifyUnitTab
          initialData={initialData}
          onSubmit={onSubmit}
          helpers={{ close: onClose, setLoading }}
        />
      ),
      actions: () => null,
    },
    {
      key: 'refranchise',
      label: 'Transfer',
      render: () => (
        <RefranchiseUnitTab
          initialData={initialData}
          onSubmit={onSubmit}
          helpers={{ close: onClose, setLoading }}
        />
      ),
      actions: () => null,
    },
  ];

  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      title="Unit Actions"
      tabs={tabs}
      defaultTabKey={defaultTabKey}
      maxWidth="xs"
    />
  );
}
